import {
  Box,
  Heading,
  HStack,
  Flex,
  Text,
  SimpleGrid,
  Image,
  GridItem,
  Icon,
} from "@chakra-ui/react";
import { HiStar } from "react-icons/hi";
import { IoPricetag } from "react-icons/io5";

import { trackFindProfessionalClick } from "../core/analytics";
import defaultAvatar from "../assets/images/defaultAvatar.png";
import stylistServiceDemo from "../assets/images/stylistServiceDemo.png";
import crownAndGlory from "../assets/images/crownAndGlory.jpg";
import crownAndGlory1 from "../assets/images/crownAndGlory1.png";
import crownAndGlory2 from "../assets/images/crownAndGlory2.png";
import senegaleseBraids from "../assets/images/senegaleseBraids.png";
import senegaleseBraids1 from "../assets/images/senegaleseBraids1.jpg";
import senegaleseBraids2 from "../assets/images/senegaleseBraids2.jpg";
import tayraHair from "../assets/images/tayraHair.jpg";
import tayraHair1 from "../assets/images/tayraHair1.jpg";
import tayraHair2 from "../assets/images/tayraHair2.jpg";

export const FindProfessionals = () => {
  const beautyProfessionals = [
    {
      id: 1,
      name: "CrownandGloryldn",
      rating: "5.0 (123)",
      pricing: "15-225",
      profileImage: crownAndGlory,
      serviceTypes: ["Salon", "Mobile"],
      serviceImages: [crownAndGlory1, crownAndGlory2],
      link: "https://booking.book-d.co.uk/profile/kalifa-c",
    },
    {
      id: 2,
      name: "ADESUCCESS",
      rating: "5.0 (120)",
      pricing: "5-180",
      profileImage: senegaleseBraids,
      serviceTypes: ["Mobile"],
      serviceImages: [senegaleseBraids1, senegaleseBraids2],
      link: "https://booking.book-d.co.uk/profile/adesuccess",
    },
    {
      id: 3,
      name: "Tayra Hair",
      rating: "4.9 (88)",
      pricing: "10-200",
      profileImage: tayraHair,
      serviceTypes: ["Salon"],
      serviceImages: [tayraHair1, tayraHair2],
      link: "https://booking.book-d.co.uk/profile/tayra-hair",
    },
  ];

  return (
    <Box
      bg="#FAF9F5"
      px={{ base: "16px", lg: "163px" }}
      py={{ base: "60px", lg: "130px" }}
      maxW={{ base: "100%", "2xl": "1700px" }}
      mx="auto"
    >
      <Flex gap={"20px"} flexDir={"column"} align={"center"}>
        <Heading
          fontSize={{ base: "28px", lg: "52px" }}
          color={"#19202D"}
          lineHeight={"100%"}
          fontFamily={"LeagueSpartan"}
          textAlign={"center"}
        >
          Looking for a hairstylist or MUA?
        </Heading>

        <Text
          fontSize={{ base: "16px", lg: "18px" }}
          color={"#19202D"}
          fontWeight={500}
          lineHeight={"140%"}
          textAlign={"center"}
        >
          Search for a service with up to 500+ professionals in the UK
        </Text>

        <Box
          as="button"
          mt="10px"
          py="20px"
          px="24px"
          bg="#19202D"
          borderRadius={"30px"}
          cursor="pointer"
          _hover={{ opacity: 0.9 }}
          onClick={() => {
            trackFindProfessionalClick();
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: "smooth",
            });
          }}
        >
          <Text
            fontSize={"16px"}
            color={"#FFFFFF"}
            fontWeight={600}
            fontFamily={"LeagueSpartan"}
            textTransform={"uppercase"}
            textAlign={"center"}
          >
            Find a beauty professional
          </Text>
        </Box>
      </Flex>

      <SimpleGrid mt="80px" columns={{ base: 1, lg: 3 }} gap={"20px"}>
        {beautyProfessionals.map((professional) => (
          <GridItem
            key={professional.id}
            borderRadius={"20px"}
            bg="#FFF"
            p="20px"
            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
          >
            <Flex
              gap={"6px"}
              cursor={"pointer"}
              onClick={() => window.open(professional.link, "_blank")}
            >
              <Image
                src={professional.profileImage || defaultAvatar}
                h={"64px"}
                w="64px"
                borderRadius={"full"}
                objectFit={"cover"}
              />

              <Box>
                <Heading
                  fontSize={"16px"}
                  color={"#19202D"}
                  fontWeight={600}
                  lineHeight={"130%"}
                >
                  {professional.name}
                </Heading>

                <HStack align={"center"}>
                  <Icon color={"#FFC266"} boxSize={5}>
                    <HiStar />
                  </Icon>

                  <Heading
                    fontSize={"14px"}
                    color={"#9BA3A3"}
                    fontWeight={400}
                    lineHeight={"150%"}
                  >
                    {professional.rating}
                  </Heading>
                </HStack>

                <HStack align={"center"}>
                  <Icon color={"#8FD3D6"} boxSize={5}>
                    <IoPricetag />
                  </Icon>

                  <Heading
                    fontSize={"14px"}
                    color={"#19202D"}
                    fontWeight={400}
                    lineHeight={"150%"}
                  >
                    £ {professional.pricing}
                  </Heading>
                </HStack>
              </Box>
            </Flex>

            <Flex gap={"8px"} mt="10px" mb="8px">
              <Box bg="#FFF7F3" py="3px" px="8px" borderRadius={"4px"}>
                <Heading
                  fontSize={"12px"}
                  color={"#FF8E3C"}
                  fontWeight={400}
                  lineHeight={"130%"}
                >
                  Hair stylist
                </Heading>
              </Box>

              {professional.serviceTypes.map((serviceType, index) => (
                <Box
                  key={index}
                  bg="#DBF1F2"
                  py="3px"
                  px="8px"
                  borderRadius={"4px"}
                >
                  <Heading
                    fontSize={"12px"}
                    color={"#267684"}
                    fontWeight={400}
                    lineHeight={"130%"}
                  >
                    {serviceType}
                  </Heading>
                </Box>
              ))}
            </Flex>

            <SimpleGrid columns={2} gap="4px">
              {professional.serviceImages.map((image, index) => (
                <Image
                  key={index}
                  src={image || stylistServiceDemo}
                  objectFit={"cover"}
                  borderRadius={"4px"}
                  h="277px"
                />
              ))}
            </SimpleGrid>
          </GridItem>
        ))}
      </SimpleGrid>
    </Box>
  );
};
